import { useUnit } from 'effector-react';
import { $global } from 'models/store-global';
import styled from 'styled-components';

const AdvisorLogo = () => {
    const community = useUnit($global.map((state) => state.community));
    const advisorData = community?.advisorData;

    return advisorData && advisorData.imageUrl ? <Logo src={advisorData.imageUrl} alt="Advisor logo" /> : null;
};

const Logo = styled.img`
    max-height: 60px;

    @media (max-width: 576px) {
        max-width: 100px;
    }
`;

export default AdvisorLogo;
